module.exports = __webpack_public_path__ + "static/media/form-light.75d6d339.svg";